module.exports = __webpack_public_path__ + "img/plac.a528d28a.jpg";